import type { FaireProductEntity } from "../../entity_types/product";

export const p_smzyrbb2y2: FaireProductEntity = {
  token: "p_smzyrbb2y2",
  type: "product",
  name: "SET - Contrast Crop Bra Tank and Ankle Leggings",
  brandToken: "b_7xecg84a7q",
  brandName: "90 Degree by Reflex & Yogalicious",
  imageUrl:
    "https://cdn.faire.com/fastly/faccc753e3674400891aecb4b10b82471a67c7c73b9cb5dbb637050706317d21.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07e87aa9b24264612c225ac0630108fcd1f1b821a9f46fbdb018bf4de99d6ac4.jpeg",
    "https://cdn.faire.com/fastly/a400772df7547493562a65f8100cd9dd4bc4ecef5c275d402cc81f06f5baa6ec.jpeg",
    "https://cdn.faire.com/fastly/acbfc66610bec22ccc805a5115980f8577b2d21442b5a089626c2ca767eab61f.jpeg",
    "https://cdn.faire.com/fastly/24d60fc03edd80fc0882631909b8790a18b0088a0e3a21ca4817595fe9d0edd9.jpeg",
    "https://cdn.faire.com/fastly/f921a4242d59510527547dd46d8a973339b4660a25cabd87c4cfe2c390d788b1.jpeg",
    "https://cdn.faire.com/fastly/621a7f8dfe8f4daa4524b619e5e43d67df7046fd1e8c24775864ad68bac11b63.jpeg",
    "https://cdn.faire.com/fastly/39a28fda4971bf453bf79e016ff5be8483f0c8a7f7ccc9176cf409beabb3eaa5.jpeg",
  ],
  priceDollars: 14.5,
  description:
    "New SET! Contrast Crop Bra Tank and Ankle Leggings - Designed with style and comfort in mind \n\n- Contrast Pipping Design\n- Ankle length\n- Elastic free waist band\n- Pre-packed, XS-S-M-L / 1-2-2-1",
  tags: [],
  msrpDollars: 30,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:36.710Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
